var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDagger(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M341.793 128L216 128V24C216 10.745 205.255 0 192 0H192C178.745 0 168 10.745 168 24V128L42.206 128C21.279 128 2.249 143.099 0.201 163.926C-2.155 187.888 16.531 208 40 208C59.25 208 74.625 194.125 78.375 176H112V408L175.375 503.125C179.375 509 185.625 512 192 512S204.625 509 208.625 503.125L272 408V176H305.625C309.375 194.125 324.75 208 344 208C367.468 208 386.155 187.888 383.799 163.926C381.751 143.099 362.721 128 341.793 128ZM224 393.5L192 441.5L160 393.5V176H224V393.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDagger);
export default __webpack_public_path__ + "static/media/dagger.1d66c2f108c3e747369089d66a75f9c7.svg";
export { ForwardRef as ReactComponent };